import { Column, TABLE_ACTION, defaultColDef, defaultColActionDef, formatter } from '@qrios/frontend-library';

import locales from '../../../../../../constants/commonLocales';
import { predefinedColumns } from '../../../../../common/table/columns/predefinedColumns';
import { withNullFallback } from '../../../../../../constants/helpers/utils';

const ACTIONS = [TABLE_ACTION.INFO];

export const columns: Column[] = [
  {
    ...defaultColDef,
    field: 'id',
    headerName: locales.table.column.operationId,
    flex: 1,
    minWidth: 150
  },
  predefinedColumns.date({}),
  predefinedColumns.status({}),

  {
    ...defaultColDef,
    field: 'sku',
    headerName: locales.table.column.sku,
    flex: 1
  },
  {
    ...defaultColDef,
    field: 'acquirerMsisdn',
    headerName: locales.table.column.acquirer,
    flex: 1,
    minWidth: 120
  },
  {
    ...defaultColDef,
    field: 'operator',
    headerName: locales.table.column.operator,
    flex: 1,
    valueFormatter: value => {
      if (value.value === null || value.value === undefined) {
        return withNullFallback(value.value);
      }
      return value.value;
    }
  },
  {
    ...defaultColDef,
    field: 'amount',
    headerName: locales.table.column.amount,
    flex: 1,
    valueFormatter: formatter.amountFormatter
  },
  predefinedColumns.cost({}),
  {
    ...defaultColActionDef(ACTIONS)
  }
];
